






























































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from "vue-property-decorator";
import { Account } from "@/models/Account";
import { EventBus } from "../event-bus";

@Component({
  components: {},
})
export default class Keys extends Vue {
  @Prop() readonly value!: boolean;

  private expUsers:Array<Account>=[];
  private search="";
  private headers = [
    {
      text: "Name",
      align: "start",
      value: "firstName",
      sortable: true,
    },
    {
      text: "Location",
      value: "location",
      sortable: true,
      align: "start",
    },
    {
      text: "Remaining Keys",
      value: "activeKeys",
      sortable: true,
      align: "start",
    },
  ];




  get show() {
    return this.value;
  }
  set show(value: boolean) {
    EventBus.$emit("closeShowExpiringKeysModal", value);
  }

  created() {
    //console.log("ekm createsd")

    EventBus.$on("closeShowExpiringKeysModal", () => {
      this.expUsers=[];
    });

    EventBus.$on("openShowExpiringKeysModal", (usersArray: Array<Account>) => {
      this.createExpUsers(usersArray);
      console.log("Expusers ",this.expUsers)
    });
  }
  
  private createExpUsers(users:Array<Account>) {
      users.forEach((user: Account) => {
            (user.activeKeys<this.$store.state.limit)?this.expUsers.push(user):"";
    });
    
  }
// close modal and clear input fields
  private cancel(): void {
    this.show = false;
    this.expUsers=[];
    EventBus.$emit("closeShowExpiringKeysModal", null);

  }


}
